"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileStore = void 0;
const file_stream_1 = require("./file_stream");
const log_1 = require("./log");
const utils_1 = require("./utils");
const web_file_1 = require("./web_file");
const MB = 1e6;
class FileStore {
    constructor(options) {
        this.queue = [];
        this.options = (0, utils_1.trueAssign)({ maxFileSize: 10 * MB, expireDay: 2 }, options);
        (0, log_1.debug)("filestore", this.options);
    }
    static getInstance(options) {
        if (!FileStore.instance) {
            FileStore.instance = new FileStore(options);
        }
        return FileStore.instance;
    }
    async init() {
        if (!navigator.storage || !("persist" in navigator.storage)) {
            throw new Error("Persist is not available.");
        }
        const persistent = await navigator.storage.persist();
        if (!persistent) {
            throw new Error("persistent not allowed!");
        }
        (0, log_1.debug)("presistance", persistent);
        const root = await navigator.storage.getDirectory();
        this.logsDir = await root.getDirectoryHandle("logs", { create: true });
        const today = new Date();
        const todayFilename = (0, utils_1.getBaseFilename)(today);
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const yesterdayFilename = (0, utils_1.getBaseFilename)(yesterday);
        (0, log_1.debug)("init", todayFilename, yesterdayFilename);
        for await (const [name] of this.logsDir) {
            const file = await (await this.logsDir.getFileHandle(name)).getFile();
            (0, log_1.debug)("file", name, file.size);
            if (name.startsWith(todayFilename) || name.startsWith(yesterdayFilename))
                continue;
            try {
                (0, log_1.debug)("remove entry", name);
                this.logsDir.removeEntry(name);
            }
            catch (error) {
                (0, log_1.debug)("remove entry failed", error);
            }
        }
        const pack = new file_stream_1.LogsPack(this.logsDir, todayFilename, this.options.maxFileSize);
        await pack.create();
        (0, log_1.debug)("file store", this.queue);
        this.queue.forEach((log) => {
            pack.writeLine((0, utils_1.formatLine)(log.date, log.tag, log.level, log.args));
        });
        this.queue = [];
        this.log = pack;
    }
    async save(date, tag, level, args) {
        if (!this.log) {
            this.queue.push({ date, args, tag, level });
            return;
        }
        this.log.writeLine((0, utils_1.formatLine)(date, tag, level, args));
    }
    async report() {
        if (!this.logsDir)
            return;
        const files = [];
        for await (const [name] of this.logsDir) {
            if (!name.endsWith(".log"))
                continue;
            const fileHandle = await this.logsDir.getFileHandle(name);
            const file = await fileHandle.getFile();
            files.push(new web_file_1.WebFile(file));
        }
        return files;
    }
    clean() {
        throw new Error("Method not implemented.");
    }
}
exports.FileStore = FileStore;
